




































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class SubmissionFormContactInfoItem extends Vue {
  @PropSync("data", { type: String }) private syncedData!: string;
  @Prop() private id!: string;
  @Prop({ default: "text" }) private type!: string;
  @Prop() private rules!: string;
  @Prop() private mask!: string;
  @Prop() private placeholder!: string;
}
